<div class="checkout-pay">
  <div class="column--left">
    <app-checkout-sidebar [content]="content?.fields.sidebar"></app-checkout-sidebar>
  </div>
  <div class="column--right">
    <app-pay [content]="content"></app-pay>
  </div>
</div>
